// feature flag names should start with the toolConfig name
export var OrgFeatureFlagTypes;
(function (OrgFeatureFlagTypes) {
    // flagName: joinCaseInsensitive, flagValue: boolean
    OrgFeatureFlagTypes["JoinCaseInsensitive"] = "joinCaseInsensitive";
    // flagName: symonSparkPartitionNumber, flagValue: '{  <elementID1>: Value , <elementID2>: Value }', objectId: <pipeID>
    OrgFeatureFlagTypes["SymonSparkPartitionNumber"] = "symonSparkPartitionNumber";
    // flagName: symonForceDecimal, flagValue: boolean
    OrgFeatureFlagTypes["SymonForceDecimal"] = "symonForceDecimal";
    // flagName: requireChangeRequest, flagValue: boolean
    OrgFeatureFlagTypes["RequireChangeRequest"] = "requireChangeRequest";
    // flagName: incentivesRoles, flagValue: boolean
    OrgFeatureFlagTypes["IncentivesRoles"] = "incentivesRoles";
    OrgFeatureFlagTypes["IncentivesS3DataProcessing"] = "incentivesS3DataProcessing";
})(OrgFeatureFlagTypes || (OrgFeatureFlagTypes = {}));
//# sourceMappingURL=orgFeatureFlagTypes.js.map